exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".indented[data-v-804d79b6]{margin:20px;max-width:550px}.spacer[data-v-804d79b6]{height:25px;border:0 solid #000;clear:both}.smallspacer[data-v-804d79b6]{height:5px;border:0 solid #000;clear:both}.spaced[data-v-804d79b6]{margin-bottom:10px}.image[data-v-804d79b6]{width:90px;float:left;margin-right:20px}.button[data-v-804d79b6]{border:1px solid gray}.prodname[data-v-804d79b6]{font-size:10px}.proditem[data-v-804d79b6]{float:left;margin-right:15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-804d79b6","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/Comp_ProductDetails.vue
// module id = 157
// module chunks = 0